import React from 'react';
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page } from '@syncfusion/ej2-react-grids';
import { Box } from '@mui/material';
import { useMsal, useAccount } from '@azure/msal-react';
import { WriteoffApprovalView } from '../../../../../services/WriteoffService/types/writeoffTypes';

// Feature imports
import { ActionButton } from './components';
import { approvalStatusTemplate, approverTemplate, approvalDateTemplate, thresholdTemplate } from './templates';
import { gridContainerStyles } from './styles';

interface ApprovalsGridProps {
  approvals: WriteoffApprovalView[];
  isInApprovalStatus: boolean;
  onApprovalAction: (approval: WriteoffApprovalView, readOnly?: boolean) => void;
}

export const ApprovalsGrid: React.FC<ApprovalsGridProps> = ({
  approvals,
  isInApprovalStatus,
  onApprovalAction
}) => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const userDisplayName = account?.name || '';

  // Action button template - needs closure over component state
  const actionTemplate = (props: WriteoffApprovalView) => (
    <ActionButton
      approval={props}
      approvals={approvals}
      userDisplayName={userDisplayName}
      isInApprovalStatus={isInApprovalStatus}
      onApprovalAction={onApprovalAction}
    />
  );

  return (
    <Box sx={gridContainerStyles}>
      <GridComponent dataSource={approvals} pageSettings={{ pageSize: 25 }} height="auto">
        <ColumnsDirective>
          <ColumnDirective field="level" headerText="Level" width="60" />
          <ColumnDirective
            field="requiredApprover"
            headerText="Approver"
            width="180"
            template={approverTemplate}
          />
          <ColumnDirective
            field="minAmount"
            headerText="Threshold"
            width="140"
            template={thresholdTemplate}
          />
          <ColumnDirective
            field="status"
            headerText="Status"
            width="120"
            template={approvalStatusTemplate}
          />
          <ColumnDirective
            field="approvedDate"
            headerText="Date"
            width="100"
            template={approvalDateTemplate}
          />
          <ColumnDirective
            headerText={isInApprovalStatus ? 'Actions' : 'View'}
            width="80"
            textAlign="Center"
            template={actionTemplate}
          />
        </ColumnsDirective>
        <Inject services={[Page]} />
      </GridComponent>
    </Box>
  );
};

export default ApprovalsGrid;
